import { connect } from 'react-redux'
import TeamMembers from './TeamMembers'
import * as actions from '../../redux/branches'

const mapStateToProps = (state) => ({
  teamMembers: state.branches.teamMembers
})

export default connect(mapStateToProps, actions)(TeamMembers)
